import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Es para principiantes?',
    a: 'Sí, el sistema está diseñado para llevarte desde los fundamentos básicos hasta estrategias avanzadas. Ideal si recién empezás o si estás estancado.'
  }, {
    q: '¿Necesito entrenador?',
    a: 'No. PÁDEL MASTER PACK está pensado para que puedas aplicar las mejoras por tu cuenta y ver resultados inmediatos en tus partidos.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar tu compra, recibirás un correo electrónico con acceso instantáneo a la plataforma donde podrás descargar todos los tomos y bonos.'
  }, {
    q: '¿Es un curso o un ebook?',
    a: 'Es un pack digital de 6 tomos en formato texto/guía (ebooks premium) altamente visuales, diseñados para lectura rápida y aplicación práctica.'
  }, {
    q: '¿Cuánto tiempo tengo acceso?',
    a: 'El acceso es de por vida. Podés descargar el material y consultarlo las veces que quieras.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Totalmente. El formato está optimizado para que puedas leerlo cómodamente desde tu celular, tablet o computadora.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 bg-padel-dark border-t border-white/5" data-id="element-72">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-73">
        <FadeIn data-id="element-74">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-10 uppercase" data-id="element-75">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-76">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-77">
              <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden" data-id="element-78">
                <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-4 flex items-center justify-between text-left font-bold text-lg hover:bg-white/5 transition-colors focus:outline-none focus:ring-2 focus:ring-neon" data-id="element-79">
                  {faq.q}
                  <ChevronDown className={`w-5 h-5 text-neon transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-80" />
                </button>
                <AnimatePresence data-id="element-81">
                  {openIndex === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-82">
                      <div className="px-6 pb-4 text-gray-300" data-id="element-83">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}